// const apiUrl = "http://192.168.0.111:7699/api/v1";
// const apiUrl = "https://xpresswheels.tchub.in/api/v1";
// const apiUrl = "http://localhost:7699/api/v1";
 const apiUrl = "https://api.mech99.com/api/v1";
export default apiUrl;

